export default {"src":"/_next/static/media/payment.66cc7190.svg","height":674,"width":856,"blurWidth":0,"blurHeight":0};